export function hasCycleCountReopenPermission(role) {
    return role?.ccUpdate === true && (role?.ccManagerApprove === true || role?.ccFinanceApprove === true);
}

export function getCycleCountReopenError(cycleCount) {
    if (cycleCount.status === 'COMPLETE' || cycleCount.inventorySyncedAt || cycleCount.inventoryAppliedSkus?.length > 0) {
        return 'Cycle count cannot be reopened after completion or inventory posting. Please create a new cycle count.';
    }

    if (!['PENDING_MANAGER_APPROVAL', 'PENDING_FINANCE_APPROVAL'].includes(cycleCount.status)) {
        return 'Only cycle counts awaiting manager or finance approval can be reopened.';
    }

    return null;
}
